import { SmartImage } from 'components/global/SmartImage';
import React from 'react';
import { IngredientsPop } from './';
import type { IngredientsPopEntry } from 'schema';

export const ContentfulIngredientsPop = ({
  ingredients,
  ...props
}: IngredientsPopEntry) => {
  return (
    <IngredientsPop
      {...props}
      ingredients={ingredients.map(({ iconImage, ...props }) => ({
        ...props,
        iconImage: iconImage && <SmartImage {...iconImage} />,
      }))}
    />
  );
};
